import React, { useState, useEffect } from "react";
import userimg from "../../assets/user.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation, Pagination } from "swiper/modules";
export default function RightResponsivesidebar() {
    return (
        <div className="slider-md-swiper">
            <aside className=" bg-white p-3  md:hidden">
                <div className="">
                    {/* Followers Section */}
                    <h3 className="followers-title mb-4">Based on Your Followers</h3>
                    <Swiper
                        spaceBetween={10}
                        slidesPerView={3}
                        // navigation
                        // pagination={{ clickable: true }}
                        modules={[Navigation, Pagination]}
                    >
                        {[1, 2, 3, 4].map((user) => (
                            <SwiperSlide key={user}>
                                <div className="followers ">
                                    <img src={userimg} alt="User" className="w-15 h-15 rounded-full" />
                                    <div className="">
                                        <p className="titlesemibold">Marketing Group</p>
                                        <p className="members">764 members</p>
                                    </div>
                                    <button className="follow-cta">Follow</button>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>

                    <hr className="my-4" />

                    {/* Groups Section */}
                    <h3 className="followers-title mt-6 mb-4">Based on Your Groups</h3>
                    <Swiper
                        spaceBetween={10}
                        slidesPerView={3}
                        // navigation
                        // pagination={{ clickable: true }}
                        modules={[Navigation, Pagination]}
                    >
                        {[1, 2, 3].map((group) => (
                            <SwiperSlide key={group}>
                                <div className="followers">
                                    <img src={userimg} alt="User" className="w-15 h-15 rounded-full" />
                                    <div className="">
                                        <p className="titlesemibold">Marketing Group</p>
                                        <p className="members">764 members</p>
                                    </div>
                                    <button className="follow-cta">Follow</button>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </aside>
        </div>
    );
}
